import {
	DELETE_PRODUCER,
  DELETE_PRODUCER_SUCCESS,
	DELETE_PRODUCER_FAIL
} from "./Constants"

const initialState = {
		isLoading: false,
		error: null,
		deletedData: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case DELETE_PRODUCER:
			return {
				...state,
					isLoading: true
			}
		case DELETE_PRODUCER_SUCCESS:
			return {
				...state,
					isLoading: false,
					deletedData: action.payload
			}
		case DELETE_PRODUCER_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}